// extracted by mini-css-extract-plugin
module.exports = {"social-box":"style_social-box__u3G5_"};